import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@mui/material/TextField";
import { currencyList, currencyMap } from "@common/contracts";
import { textFieldStyle } from "../../../../assets/styles/styles";
import { Box } from "@mui/material";
import { makeStyles } from "@material-ui/core";
export const SelectCurrency = ({ value, sx = {}, onChange, ...props }) => {
    const useStyles = makeStyles({
        root: {
            width: 300,
            ...textFieldStyle,
            ...sx,
        },
    });
    const classes = useStyles();
    return (_jsx(Autocomplete
    // @ts-ignore
    , { 
        // @ts-ignore
        value: currencyMap[value], 
        // @ts-ignore
        options: currencyList, getOptionLabel: (i) => {
            return i ? `${i.code} ${i.name} ${i.symbol}` : '';
        }, onChange: onChange, className: classes.root, renderInput: (params) => _jsx(TextField, { label: "select a currency", variant: "outlined", ...params }, void 0), renderOption: (i) => (_jsx(Box, { component: "li", children: _jsxs(Box, { children: [_jsx(Box, { children: i.name }, void 0), _jsxs(Box, { sx: { fontSize: '0.85rem', opacity: 0.9, whiteSpace: "pre-wrap" }, children: [i.code, " ", i.symbol] }, void 0)] }, void 0) }, void 0)), ...props }, void 0));
};
//# sourceMappingURL=SelectCurrency.js.map